import React from "react"
import classNames from "classnames"
import { FormElement } from "./form"
import { withFieldLabelAndHint } from "./field"

type Props = {
  children: any
  forwardedRef?: React.Ref<HTMLSelectElement>
} & FormElement &
  React.SelectHTMLAttributes<HTMLSelectElement>

const Select = ({ children, status, forwardedRef, ...selectProps }: Props) => {
  return (
    <div
      className={classNames("cobalt-SelectField", {
        "cobalt-SelectField--success": status === "success",
        "cobalt-SelectField--error": status === "error",
      })}
    >
      <select
        {...selectProps}
        ref={forwardedRef}
        className="cobalt-SelectField__Input"
      >
        {children}
      </select>
    </div>
  )
}

const wrappedComponent = withFieldLabelAndHint(Select)
wrappedComponent.displayName = "Select"

export { wrappedComponent as Select }
